<template>
  <div class="pagination">
    <button
      v-if="activePage !== 0"
      class="prev-page-btn"
      @click="changePage(activePage - 1)"
    >
      <img
        src="@/assets/arrow-right-black.svg"
        alt="heart"
        title="Usuń do ulubionych"
      />
    </button>
    <div v-if="totalPages > 8">
      <button v-if="activePage > 4" class="spacer"></button>
      <button
        v-for="page in pages"
        :key="page"
        class="page-btn"
        :class="{ active: activePage === page }"
        @click="changePage(page)"
      >
        {{ page + 1 }}
      </button>
    </div>
    <div v-else>
      <button
        v-for="page in pages"
        :key="page"
        class="page-btn"
        :class="{ active: activePage === page }"
        @click="changePage(page)"
      >
        {{ page + 1 }}
      </button>
    </div>
    <button
      v-if="activePage + 1 !== totalPages"
      class="next-page-btn"
      @click="changePage(activePage + 1)"
    >
      <img
        src="@/assets/arrow-right-black.svg"
        alt="heart"
        title="Usuń do ulubionych"
      />
    </button>
  </div>
</template>

<script>
export default {
  name: 'list-pagination',
  props: {
    totalPages: { type: Number, required: true },
    activePage: { type: Number, required: true },
    setActivePage: { type: Function, required: true },
  },
  computed: {
    sliceMin() {
      let sliceMin = this.activePage > 4 ? this.activePage - 3 : 0;
      return this.activePage + 4 >= this.totalPages
        ? this.totalPages - 7
        : sliceMin;
    },
    sliceMax() {
      return this.activePage > 4 ? this.activePage + 4 : 7;
    },
    pages() {
      return Array(this.totalPages)
        .fill()
        .map((_, i) => i)
        .slice(this.sliceMin, this.sliceMax);
    },
  },
  methods: {
    changePage(page) {
      this.setActivePage(page);
    },
  },
  watch: {
    totalPages(val) {
      if (val < this.activePage) {
        this.changePage(0);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 0 20px;
  div {
    display: flex;
  }
  @media (min-width: 576px) {
    padding: 0 0 40px;
  }
  @media (min-width: 992px) {
    padding: 0 0 60px;
  }
}

.page-btn {
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  cursor: pointer;
  font-size: 16px;
  background: transparent;
  color: #000;
  border: none;
  &:hover {
    background: #f7f7f7;
  }
  @media (max-width: 440px) {
    width: 35px;
  }
  @media (max-width: 360px) {
    width: 30px;
  }
  &.active {
    background: $primaryColor;
    color: #fff;
    &:hover {
      background: $primaryColor;
    }
  }
}

.next-page-btn {
  @extend .page-btn;
  background: #f3f0ee;
  &:hover {
    background: #f3f0ee;
  }
}

.prev-page-btn {
  @extend .next-page-btn;
  transform: rotate(180deg);
}

.spacer {
  @extend .page-btn;
  position: relative;
  cursor: default;
  &:after {
    content: '...';
    position: absolute;
    font-size: 26px;
    top: -2px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
